import React from 'react'
import styles from '../../styles/modules/common/brand-filter.module.scss'
import Button from '../button'
import { Brand, BrandCode } from '../../../core/brands'

interface BrandFilterProps {
  currentBrand: BrandCode
  onBrandChange: (brand: BrandCode) => void
  onFilterClick: () => void
  isAdminOnly: boolean
  brands: Brand[]
  className?: string
  isLoading?: boolean
}

export const BrandFilter: React.FC<BrandFilterProps> = ({
  currentBrand,
  onBrandChange,
  onFilterClick,
  isAdminOnly,
  brands,
  className,
  isLoading = false,
}) => {
  const shouldRender = isAdminOnly && brands.length > 0
  if (!shouldRender) {
    return null
  }

  // 動的ブランドオプション
  const brandOptions = [
    ...brands.map(brand => ({
      value: brand.code,
      label: brand.name,
      key: brand.code,
    })),
  ]

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    onBrandChange(value as BrandCode)
  }

  return (
    <div className={`${styles.brandFilter} ${className || ''}`}>
      <div>
        <label htmlFor="brand-select" className={styles.label}>
          ブランドで絞り込む
        </label>
        <select
          id="brand-select"
          className={styles.selectBox}
          value={currentBrand || ''}
          onChange={handleSelectChange}
        >
          {brandOptions.map(option => (
            <option key={option.key} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <Button
        title="絞り込む"
        onClick={onFilterClick}
        className={styles.filterButton}
        isLoading={isLoading}
      />
    </div>
  )
}

export default BrandFilter
